module.exports = "<h2 mat-dialog-title>Resultado de Envío</h2>\r\n<mat-dialog-content>\r\n<table class=\"table table-bordered\">\r\n\t<thead>\r\n\t\t<tr><th>Mensaje</th></tr>\r\n\t</thead>\r\n\t<tbody>\r\n\t\t<tr *ngFor=\"let mensaje of mensajes\"><td>{{mensaje}}</td></tr>\r\n\t</tbody>\r\n</table>\r\n</mat-dialog-content>\r\n<mat-dialog-actions>\r\n  <button mat-button mat-dialog-close>Ok</button>\r\n</mat-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// D:/REPO/FacturacionWeb/src/app/main/content/EnviarFacturas/ResultadosEnvio.component.html
// module id = ../../../../../src/app/main/content/EnviarFacturas/ResultadosEnvio.component.html
// module chunks = main